// Generated file - do not change manually!
/**
 * Different types of ListItem.
 */
export var ListItemType;
(function (ListItemType) {
    /**
     * Indicates that the item is clickable via active feedback when item is pressed.
     */
    ListItemType["Active"] = "Active";
    /**
     * Enables detail button of the list item that fires detail-click event.
     */
    ListItemType["Detail"] = "Detail";
    /**
     * Indicates the list item does not have any active feedback when item is pressed.
     */
    ListItemType["Inactive"] = "Inactive";
})(ListItemType || (ListItemType = {}));
